import {I18n} from 'aws-amplify/utils';
import {FlexiDeleteButton} from '@flexinet/ui-components';

// FNP-1192 — the Delete button.
//
// ⚠️ USES THE SHARED FlexiDeleteButton. A private copy here would be drift — a
// styling fix would reach this module and not the others.
//
// ⚠️ WHETHER THIS RENDERS AT ALL is decided by the CALLER, on
// `canWriteRecords`. This component owns the count and the disabled state;
// hiding on capability is a separate decision and lives with the toolbar.
export const DeleteRecordButton = (
    {
        count = 0,
        onClick,
        disabled = false,
    }: {
        count?: number,
        onClick: () => void,
        disabled?: boolean,
    },
) => {

    return (
        <FlexiDeleteButton
            onClick={onClick}
            // Disabled at zero rather than hidden: the button is a permanent
            // part of a toolbar the tenant CAN use, and a control that appears
            // and disappears as rows are ticked is harder to find than one that
            // greys out.
            disabled={disabled || count === 0}
        >
            {count > 0
                ? `${I18n.get('Delete')} (${count})`
                : I18n.get('Delete')}
        </FlexiDeleteButton>
    );
};
